import React from 'react';
import { HiOutlineExternalLink } from 'react-icons/hi';
import pm from '../../assets/images/pm.png';
import em from '../../assets/images/em.png';
import pg from '../../assets/images/pg.png';

const Portfolio = () => {
    return (
        <section className="bg-secondary">
            <div className="pb-10 px-4 lg:px-60 md:px-32">
                <div className="mt-16 py-8">
                    <h2 className="text-center text-4xl text-accent font-bold">
                        Recent Projects
                    </h2>
                    <div className="flex items-center mt-2 mb-4">
                        <span className="h-0.5 bg-accent w-24"></span>
                        <p className="ml-3">My Creative Portfolio</p>
                    </div>
                </div>
                <div className="flex justify-between flex-wrap">
                    {/* =================single card=================== */}
                    <div className="card glass lg:w-96 card-compact bg-primary shadow-xl mb-10 lg:mb-5">
                        <figure>
                            <img
                                data-aos="zoom-out-up"
                                data-aos-duration="2000"
                                className="sm:max-w-sm"
                                src={pm}
                                alt="Shoes"
                            />
                        </figure>
                        <div className="card-body">
                            <div className="flex items-center mt-2 mb-4">
                                <span className="h-0.5 bg-accent w-24"></span>
                                <p className="ml-3">App UI Concept</p>
                            </div>
                            <p>
                                This is a MERN FULL STACK project created using
                                <br />
                                <br />
                                <span className="text-accent font-bold">
                                    Client:
                                </span>{' '}
                                HTML5, CSS3, JavaScript, React, DaisyUI,
                                Tailwind CSS, Axios, React query(tanstac), React
                                hook form, React countup, Sweetalert2, React
                                toastify, React icons, React firebase hooks
                                <br />
                                <br />
                                <span className="text-accent font-bold">
                                    Server:
                                </span>{' '}
                                NodeJS, Express, MongoDB, Stripe payment process
                            </p>
                            <div className="lg:text-center">
                                <a
                                    className="flex items-center justify-center"
                                    href="https://pcx-material.web.app/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <button className="btn btn-accent rounded-sm text-white">
                                        Live site{' '}
                                        <HiOutlineExternalLink
                                            className="ml-1"
                                            size={18}
                                        />
                                    </button>
                                </a>
                            </div>
                            <div className="lg:flex justify-between">
                                <div className="mb-2 lg:mb-0">
                                    <a
                                        className="flex items-center justify-center"
                                        href="https://github.com/palakxdev/pcx-material-client"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <button className="btn btn-accent rounded-sm text-white">
                                            github client{' '}
                                            <HiOutlineExternalLink
                                                className="ml-1"
                                                size={18}
                                            />
                                        </button>
                                    </a>
                                </div>
                                <div>
                                    <a
                                        className="flex items-center justify-center"
                                        href="https://github.com/palakxdev/pcx-material-server"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <button className="btn btn-accent rounded-sm text-white">
                                            github server{' '}
                                            <HiOutlineExternalLink
                                                className="ml-1"
                                                size={18}
                                            />
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* =================single card=================== */}
                    <div className="card glass lg:w-96 card-compact bg-primary shadow-xl mb-10 lg:mb-5">
                        <figure>
                            <img
                                data-aos="zoom-out-up"
                                data-aos-duration="2000"
                                className="sm:max-w-sm"
                                src={em}
                                alt="Shoes"
                            />
                        </figure>
                        <div className="card-body">
                            <div className="flex items-center mt-2 mb-4">
                                <span className="h-0.5 bg-accent w-24"></span>
                                <p className="ml-3">App UI Concept</p>
                            </div>
                            <p>
                                This is a MERN FULL STACK project created using
                                <br />
                                <br />
                                <span className="text-accent font-bold">
                                    Client:
                                </span>{' '}
                                HTML5, CSS3, JavaScript, React, Bootstrap, React
                                bootstrap, React countup, React slick and slick
                                carousel, React scrool trigger, Sweetalert,
                                React toastify, React icons, React firebase
                                hooks
                                <br />
                                <br />
                                <span className="text-accent font-bold">
                                    Server:
                                </span>{' '}
                                NodeJS, Express, MongoDB
                            </p>
                            <div className="lg:text-center">
                                <a
                                    className="flex items-center justify-center"
                                    href="https://electro-max.web.app/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <button className="btn btn-accent rounded-sm text-white">
                                        Live site{' '}
                                        <HiOutlineExternalLink
                                            className="ml-1"
                                            size={18}
                                        />
                                    </button>
                                </a>
                            </div>
                            <div className="lg:flex justify-between">
                                <div className="mb-2 lg:mb-0">
                                    <a
                                        className="flex items-center justify-center"
                                        href="https://github.com/palakxdev/electro-max-client"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <button className="btn btn-accent rounded-sm text-white">
                                            github client{' '}
                                            <HiOutlineExternalLink
                                                className="ml-1"
                                                size={18}
                                            />
                                        </button>
                                    </a>
                                </div>
                                <div>
                                    <a
                                        className="flex items-center justify-center"
                                        href="https://github.com/palakxdev/electro-max-server"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <button className="btn btn-accent rounded-sm text-white">
                                            github server{' '}
                                            <HiOutlineExternalLink
                                                className="ml-1"
                                                size={18}
                                            />
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* =================single card=================== */}
                    <div className="card glass lg:w-96 card-compact bg-primary shadow-xl mb-10 lg:mb-5">
                        <figure>
                            <img
                                data-aos="zoom-out-up"
                                data-aos-duration="2000"
                                className="sm:max-w-sm"
                                src={pg}
                                alt="Shoes"
                            />
                        </figure>
                        <div className="card-body">
                            <div className="flex items-center mt-2 mb-4">
                                <span className="h-0.5 bg-accent w-24"></span>
                                <p className="ml-3">App UI Concept</p>
                            </div>
                            <p>
                                This is a FRONT-END project created using
                                <br />
                                <br />
                                <span className="text-accent font-bold">
                                    Client:
                                </span>{' '}
                                HTML5, CSS3, JavaScript, React, Bootstrap, React
                                bootstrap, React toastify, React icons, React
                                firebase hooks
                                <br />
                                <br />
                                <span className="text-accent font-bold">
                                    Server:
                                </span>{' '}
                                Not applied
                            </p>
                            <div className="lg:flex justify-between">
                                <div className="mb-2 lg:mb-0">
                                    <a
                                        className="flex items-center justify-center"
                                        href="https://perfect-gym-dc72e.web.app/"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <button className="btn btn-accent rounded-sm text-white">
                                            Live site{' '}
                                            <HiOutlineExternalLink
                                                className="ml-1"
                                                size={18}
                                            />
                                        </button>
                                    </a>
                                </div>
                                <div>
                                    <a
                                        className="flex items-center justify-center"
                                        href="https://github.com/palakxdev/perfect-gym"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <button className="btn btn-accent rounded-sm text-white">
                                            github{' '}
                                            <HiOutlineExternalLink
                                                className="ml-1"
                                                size={18}
                                            />
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="contact">
                    <p className="hidden">hello</p>
                </div>
            </div>
        </section>
    );
};

export default Portfolio;
